import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[xpo-condition-component-host]',
})
export class XpoConditionComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
